import React from "react";
import {
  LoadingListItemContainerRow,
  LoadingEventItemText,
  LoadingListItemDate,
  LoadingEventItemContainer,
  LoadingEventItemDetailHeader,
  LoadingEventItemTitle,
  LoadingEventItemBodySection
} from "../../../utils/loading-styles";


export const LoadingEventItemDetail = () => {
  return (
    <>
      <LoadingEventItemContainer>
        <LoadingEventItemDetailHeader>
        <LoadingListItemContainerRow>
          <LoadingListItemDate xs={12} md={3}>
            <h4>
              &nbsp;
            </h4>
            <span className="daynum">
              <h1>&nbsp;</h1>
            </span>
          </LoadingListItemDate>
          <LoadingEventItemText xs={12} md={9}>
            <LoadingEventItemTitle>
              <h2>&nbsp;</h2>
            </LoadingEventItemTitle>
          </LoadingEventItemText>
        </LoadingListItemContainerRow>
        </LoadingEventItemDetailHeader>
        <LoadingEventItemBodySection>
          &nbsp;
        </LoadingEventItemBodySection>
      </LoadingEventItemContainer>
    </>
  );
};
